import React from 'react';

interface TextCardProps {
  message: string;
}

export const TextCard: React.FC<TextCardProps> = ({ message }) => {
  const lines = message.split(/\r?\n/);
  return (
    <div className="bg-white rounded-2xl border border-black/[0.08] shadow-sm px-4 py-3 text-navy text-sm leading-relaxed">
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </div>
  );
};
